import Detail from '../../../../components/Detail';
import InfoPopUp from '../../../../components/InfoPopUp';
import { formatUSD } from '../../../../helpers/formats';
import usePendingAmounts from '../../../../hooks/web3/vault/usePendingAmounts';

const PendingDeposits: React.FC = () => {
    const { pendingAmounts } = usePendingAmounts();

    const pending = pendingAmounts
        ? Object.entries(pendingAmounts.spools).filter(
              ([_, { pendingDepositAmount }]) => pendingDepositAmount !== 0
          )
        : [];

    return (
        <Detail
            title={
                <>
                    <span>Your Pending Deposits</span>
                    <InfoPopUp>
                        <span>Pending Deposits:</span>
                        {pending.length ? (
                            pending.map(([spoolAddress, pendingDeposit]) => (
                                <div key={spoolAddress} className='mt'>
                                    <span className='block'>
                                        {pendingDeposit.spoolDetails?.spoolName ??
                                            'Spool'}
                                    </span>
                                    <strong className='block'>
                                        {formatUSD(
                                            pendingDeposit?.pendingDepositAmount || 0
                                        )}{' '}
                                        {pendingDeposit.spoolDetails?.underlying
                                            ?.symbol ?? 'Asset'}
                                    </strong>
                                </div>
                            ))
                        ) : (
                            <strong className='block'>N/A</strong>
                        )}
                    </InfoPopUp>
                </>
            }
            value={`~$${formatUSD(pendingAmounts?.total?.pendingDepositAmount || 0)}`}
        />
    );
};

export default PendingDeposits;
